import { useTheme } from "../hooks/useTheme";

/** A sun/moon switch between the light and dark themes. */
export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const dark = theme === "dark";

  return (
    <button
      type="button"
      role="switch"
      aria-checked={dark}
      aria-label="Dark theme"
      title={dark ? "Switch to light theme" : "Switch to dark theme"}
      onClick={() => setTheme(dark ? "light" : "dark")}
      className="relative inline-flex h-7 w-13 shrink-0 items-center rounded-full border border-gray-300 bg-gray-100 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-accent-500"
    >
      <span
        aria-hidden
        className={
          "absolute top-0.5 left-0.5 flex size-5.5 items-center justify-center rounded-full bg-surface text-gray-600 shadow-sm transition-transform " +
          (dark ? "translate-x-6" : "translate-x-0")
        }
      >
        <svg
          viewBox="0 0 24 24"
          className="size-3.5"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {dark ? (
            <path d="M20.5 14.5A8.5 8.5 0 1 1 9.5 3.5a7 7 0 0 0 11 11Z" />
          ) : (
            <>
              <circle cx="12" cy="12" r="4" />
              <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
            </>
          )}
        </svg>
      </span>
    </button>
  );
}
